import { RenderBlock } from '@rst/render-blocks/src/types'
import { createRequestStore } from '@rst/libs-ts/src/effector/request-store'
import { themedColors, createTheme, gradients } from '@rst/ui-ts/src/theme'
import {
	ColorGradientsSchemeNames,
	colorsSchemeCore,
} from '@rst/ui-ts/src/atoms/colors'

import initScrollToBlock from './scroll-to-block'
import { withBaseSiteUrl } from '../lib/with-url'
import { Store, combine, forward } from 'effector'
import { initL10N } from './init-l10n'
import { $history } from '@rst/libs-ts'
import { $locale, getLocaleFromPathname, updateConnectedLangs } from './l10n'

initScrollToBlock()

const { fx, $store } = createRequestStore<
	void,
	{ lang?: string },
	RenderBlock.Init
>(
	{
		url: withBaseSiteUrl('/api/setting'),
		params: combine({ lang: $locale }, ({ lang }) =>
			lang === 'ru' ? {} : { lang }
		),
	},

	window.__setting__ || null
)

if (!window.__setting__) {
	fx()
}

forward({
	from: $store.map(store => store?.languages),
	to: updateConnectedLangs,
})

$locale.on(
	combine({ init: $store, history: $history }),
	(_, { init: { lang, languages }, history: { pathname } }) => {
		const pathLocale = getLocaleFromPathname({ pathname, langs: languages })

		if (pathLocale) {
			return pathLocale
		}

		return lang
	}
)

const $font = $store.map(x => x?.font || null)
const $colors = $store.map(x =>
	createTheme(
		x?.colors
			? x.colors.startsWith('palette')
				? // @ts-ignore
				  Object.assign(window.__palette__, ColorGradientsSchemeNames) ||
				  colorsSchemeCore
				: themedColors[x?.colors as 'ferry']
			: colorsSchemeCore
	)
)
const $icons = $store.map(x => x?.icons || null)
const $head = $store.map(x => x?.head || ({} as RenderBlock.InitHead))
const $main = $store.map(x => x?.main || ({} as RenderBlock.InitMain))
const $lead = $store.map(x => x?.lead || ({} as RenderBlock.LeadFormData))

const { fx: fetchCustomFooterFx, $store: $customFooter } = createRequestStore<
	void,
	{ lang?: string },
	RenderBlock.CustomFooterType[]
>(
	{
		url: withBaseSiteUrl('/api/footer'),
		params: combine({ lang: $locale }, ({ lang }) =>
			lang === 'ru' ? {} : { lang }
		),
	},

	window.__footer__ || null
)

if (!window.__footer__) {
	fetchCustomFooterFx()
}

const $footer: Store<RenderBlock.InitFooter> = combine(
	{ store: $store, customFooter: $customFooter },
	({ store, customFooter }) => ({
		...(store?.footer || ({} as RenderBlock.InitFooter)),
		customItems: customFooter,
	})
)
const $pattern = $store.map(x => x?.pattern)
const { $langSetting } = initL10N($store)

const $theme = $store.map(x => ({
	colors: createTheme(
		x?.colors
			? x.colors.startsWith('palette')
				? Object.assign(
						{},
						// @ts-ignore
						window.__palette__ || {},
						ColorGradientsSchemeNames
				  ) || colorsSchemeCore
				: themedColors[x?.colors as 'ferry']
			: colorsSchemeCore
	),
	font: x?.font || null,
	gradients,
	buttonShape: x?.button || 'default',
	icons: x?.icons || null,
	borderRadius: x?.border_radius === undefined ? 8 : x.border_radius,
	inputBorderRadius:
		x?.input_border_radius === undefined ? 8 : x.input_border_radius,
	containerMaxWidth: x?.content_width || 1040,
}))

const $paletteName = $store.map(store => store?.colors)

export {
	$font,
	$colors,
	$icons,
	$head,
	$main,
	$lead,
	$footer,
	$pattern,
	$store as $maininitStoreOld,
	$theme,
	$paletteName,
	$langSetting,
	$locale,
}
